import React from 'react';
import './CardHeader.css';

type CardHeaderProps = {
  title: string;
  imageSrc: string;
  imageAlt: string;
};

export const CardHeader: React.FC<CardHeaderProps> = ({
  title,
  imageSrc,
  imageAlt,
}) => {
  return (
    <div className="card-header--container">
      <h1 className="card-header--header">{title}</h1>
      <img className="card-header--image" src={imageSrc} alt={imageAlt} />
    </div>
  );
};
